import { render, staticRenderFns } from "./subjectLives.vue?vue&type=template&id=42937ca6&scoped=true&"
import script from "./subjectLives.vue?vue&type=script&lang=js&"
export * from "./subjectLives.vue?vue&type=script&lang=js&"
import style0 from "./subjectLives.vue?vue&type=style&index=0&id=42937ca6&prod&lang=less&scoped=true&"
import style1 from "./subjectLives.vue?vue&type=style&index=1&id=42937ca6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42937ca6",
  null
  
)

export default component.exports